module.exports = __webpack_public_path__ + "static/media/database1.5d86d62d.png";